import React, { ReactNode, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { ToastContentProps } from 'react-toastify';
import { AlertBox, AlertText, CloseButton } from './ToastMessageStyled';
import { ToastTypeEnum } from './types';
import { COLOR } from '../../../theme';

const ToastType = {
  [ToastTypeEnum.INFO]: {
    type: ToastTypeEnum.INFO,
    styled: {
      color: COLOR.white,
      backgroundColor: COLOR.info,
    },
  },
  [ToastTypeEnum.SUCCESS]: {
    type: ToastTypeEnum.SUCCESS,
    styled: {
      color: COLOR.white,
      backgroundColor: COLOR.success,
    },
  },
  [ToastTypeEnum.ERROR]: {
    type: ToastTypeEnum.ERROR,
    styled: {
      color: COLOR.white,
      backgroundColor: COLOR.error,
    },
  },
  [ToastTypeEnum.WARNING]: {
    type: ToastTypeEnum.WARNING,
    styled: {
      color: COLOR.white,
      backgroundColor: COLOR.warning,
    },
  },
};

type ToastMessageProps = {
  type: ToastTypeEnum;
  text: string | ReactNode;
};

const ToastMessage = ({
  closeToast,
  toastProps,
  type = ToastTypeEnum.SUCCESS,
  text,
}: Partial<ToastContentProps & ToastMessageProps>) => {
  const styled = ToastType[type]?.styled ?? ToastType[ToastTypeEnum.SUCCESS].styled;

  useEffect(() => {
    if (closeToast) {
      setTimeout(() => closeToast(), 5000);
    }
  }, [closeToast]);

  return (
    <AlertBox sx={styled}>
      <AlertText>{text}</AlertText>
      <CloseButton onClick={closeToast}>
        <CloseIcon style={{ color: COLOR.white, fontSize: '20px' }} />
      </CloseButton>
    </AlertBox>
  );
};

export default ToastMessage;
